/* import __COLOCATED_TEMPLATE__ from './cookie-secure-flag.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import type Security from 'embercom/models/messenger-settings/security';

interface Args {
  securitySettings: Security;
}

export default class CookieSecureFlag extends Component<Args> {
  get isEnabled() {
    return this.args.securitySettings.cookieSecureFlag;
  }

  @action
  toggleEnabled() {
    this.args.securitySettings.cookieSecureFlag = !this.isEnabled;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Security::CookieSecureFlag': typeof CookieSecureFlag;
  }
}
